<template>
  <component
    :is="getComponentByType"
    :value="value"
    :dict-value="dictValue"
    :option="option"
    :disabled="disabled"
    :label="label"
    :vacation-credit-detail-list="vacationCreditDetailList"
    :item-data="itemData"
    :field="field"
    :loading.sync="loading"
    :name="name"
    :formDataAll="formDataAll"
    @input="inputChange"
  />
</template>

<script>
import components from './components/index'

export default {
  components,
  props: {
    value: {
      type: [String, Number, Object, Array, Boolean],
      default: undefined,
    },
    dictValue: {
      type: [String, Number, Object, Array, Boolean],
      default: undefined,
    },
    vacationCreditDetailList: {
      type: Array,
      default: () => {},
    },
    option: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    itemData: {
      type: Object,
      default: () => {},
    },
    field: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    formDataAll: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      saveOption: this.option || {},
    }
  },
  computed: {
    getComponentByType() {
      const type = this.saveOption.type || 'input'
      if (type === 'select') {
        const selectorTypeOps = {
          staff: 'StaffSelector',
          worker: 'WorkerSelector',
          user: 'UserSelector',
          site: 'SiteSelector',
          positiveNewStaff: 'AeesssmentSelect',

          // teams: 'TeamSelector',
        }
        if (this.option.dictCode && selectorTypeOps[this.option.dictCode]) {
          return selectorTypeOps[this.option.dictCode]
        }
        return 'defaultSelector'
      }
      if (type === 'customSelect') {
        const selectorTypeOps = {
          teams: 'TeamSelector',
        }
        if (this.option.dictCode && selectorTypeOps[this.option.dictCode]) {
          return selectorTypeOps[this.option.dictCode]
        }
        return 'defaultSelector'
      }
      return `C${type}`
    },
  },
  watch: {
    loading(e) {
      this.$emit('update:loading', e)
    },
    option: {
      deep: true,
      handler(e) {
        this.saveOption = e
      },
    },
  },
  mounted() {},
  methods: {
    inputChange(e) {
      console.log(('ssssss', e))
      this.$emit('input', e)
    },
  },
}
</script>

<style lang="scss" scoped></style>
